import * as t from 'io-ts';
import {isEmpty} from 'lodash';

import {isDefined} from '../../../helpers/typescript/typeHelpers';

/*
 * Constants.
 */

export function maybeFindRuntimeTypeLogger() {
  if (!isDefined(window)) {
    return null;
  }
  return findRuntimeTypeLogger();
}

export function findRuntimeTypeLogger() {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  return require('../../../services/logger/logger').logger.getLogger('runtime-type');
}
export interface DefaultValueFallbackReport extends Record<string, any> {
  key_paths: Array<string>;
  expected_type: string;
  actual_value: string;
}

export function reportError(errorDescription: string, error: t.ValidationError, typeName: string) {
  maybeFindRuntimeTypeLogger()?.error(...makeErrorReport(errorDescription, error, typeName));
}

export function reportWarn(errorDescription: string, error: t.ValidationError, typeName: string) {
  maybeFindRuntimeTypeLogger()?.warn(...makeErrorReport(errorDescription, error, typeName));
}

function makeErrorReport(
  errorDescription: string,
  error: t.ValidationError,
  typeName: string,
): [string, DefaultValueFallbackReport] {
  const keyPaths = error.context.slice(1).map((entry) => entry.key);
  const actualValue =
    error.value === undefined ? 'undefined' : JSON.stringify(error.value, null, 2).slice(0, 10000);

  const report = {
    key_paths: keyPaths,
    expected_type: typeName,
    actual_value: actualValue,
  };

  if (isEmpty(keyPaths)) {
    return [`[io-ts] ${errorDescription}`, report];
  }

  const normalizedPath = keyPaths
    .map((key) => {
      if (Number.isInteger(Number(key))) {
        return '*';
      }

      return key;
    })
    .join('.');

  return [`[io-ts] ${errorDescription} at ${normalizedPath}`, report];
}
